import type { TRuleWithTheme } from '@/styles/theme';

export const button: TRuleWithTheme = ({ theme }) => ({
    '&.ant-btn.ant-btn-lg': {
        fontWeight: 400,
        padding: 0,
        fontSize: '0.875rem',
        letterSpacing: 'unset',

        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',

        min768: {
            fontSize: '1rem',
        },

        '&:hover': {
            color: theme.colors.accentPrimary,
        },
    },
});

export const caret: TRuleWithTheme<{ popoverOpen: boolean }> = ({ theme, popoverOpen }) => ({
    color: popoverOpen ? `${theme.colors.accentSecondary}!important` : `${theme.colors.iconsTertiary}!important`,

    transform: popoverOpen ? 'rotate(0deg)' : 'rotate(-90deg)',
    transitionProperty: 'transform color',
    transitionDuration: '0.3s',
});

export const popover: TRuleWithTheme = ({ theme }) => ({
    '& .ant-popover-inner': {
        overflow: 'hidden',
        position: 'relative',
    },
});

export const name: TRuleWithTheme = () => ({
    whiteSpace: 'nowrap',
    paddingLeft: '0.4rem',
});
